import classNames from 'classnames';
import { useNavigate } from 'react-router';
import PatientOrgContainer from '../patient/hooks/PatientOrgContainer';
import { useReportRecoilState } from '../patient/hooks/use-report-recoil-state';
import { useSurveyState } from '../patient/hooks/use-survey-state';
import { usePaSurveyParams } from '../report/use-pa-survey-params';

import hipaa from '../assets/ill/hipaa-badge.svg';
import LogoPatient from '../components/LogoPatient';
import config from '../config';
import { useStaticLocales } from '../admin/hooks/locales/use-static-locale';

function FooterContent() {
  const { sltStr } = useStaticLocales();
  const [, { setReportState }] = useReportRecoilState();
  const [, { updateVisit }] = useSurveyState();
  const nav = useNavigate();
  const { shortId, orgId } = usePaSurveyParams();
  const container = PatientOrgContainer.useContainer();

  // Organization logo check
  const hasOrgLogo = !!container.logoUrl;

  return (
    <footer className={classNames('footer flex p-4 gap-6 text-xs items-center')}>
      <div className='flex-1 flex items-center gap-4 opacity-80'>
        <div
          className='cursor-pointer flex items-center'
          onClick={() => {
            window.open('https://www.accountablehq.com/', '_blank');
          }}
        >
          <img src={hipaa} alt='HIPAA badge' className='h-10' />
        </div>
        <div className='flex flex-col gap-1'>
          <div
            className='cursor-pointer'
            onClick={async () => {
              const nState = {
                globalAnswerMap: {},
                nextTreeKeys: [],
                presentIllness: [],
                treeStates: [],
                systemValueMap: {},
                descriptiveReport: undefined,
              };
              // reset state
              await setReportState(nState);

              updateVisit(nState);

              nav(`/s/${orgId}/${shortId}`);
            }}
          >
            <p>© 2024 CyrenCare Inc.</p>
          </div>
          <div className='flex items-center flex-wrap gap-3'>
            <a className='link' href={config.termsOfService} target='_blank' rel='noreferrer'>
              {sltStr({ key: 'footer-terms-of-use' })}
            </a>
            <a className='link' href={config.privacyPolicy} target='_blank' rel='noreferrer'>
              {sltStr({ key: 'footer-privacy-policy' })}
            </a>
          </div>
        </div>
      </div>
      <div className='flex items-center justify-end'>
        <div className='w-36 h-auto'>
          <LogoPatient className='w-full h-auto' />
        </div>
      </div>
    </footer>
  );
}

// Provider는 PaSurveyHomePage에서 감싸므로 여기서는 제거
export default FooterContent;
